<script setup lang="ts">
import { useObjectSubTypeModel } from './../model/model.ts'

const model = useObjectSubTypeModel()
</script>

<template>
  <div class="form__grid_3 form__grid_top mt-4">
    <div class="ml-2">
      <VCheckbox
        :label="$t('itf.has_file')"
        v-model="model.data.properties.has_file"
        density="compact"
      />

      <VCheckbox
        :label="$t('itf.is_bind')"
        v-model="model.data.properties.is_bind"
        density="compact"
      />

      <VCheckbox
        :label="$t('itf.is_journal_replace')"
        v-model="model.data.properties.is_journal_replace"
        density="compact"
      />

      <VCheckbox
        :label="$t('itf.is_must_accept')"
        v-model="model.data.properties.is_must_accept"
        density="compact"
      />
    </div>

    <div>
      <VCheckbox
        :label="$t('itf.is_connection_to_object')"
        v-model="model.data.properties.is_connection_to_object"
        density="compact"
      />

      <VCheckbox
        :label="$t('itf.is_tree')"
        v-model="model.data.properties.is_tree"
        density="compact"
      />

      <VCheckbox
        :label="$t('itf.is_comment')"
        v-model="model.data.properties.is_comment"
        density="compact"
      />
    </div>

    <VTextarea :label="$t('itf.description')" v-model="model.data.properties.description" />
  </div>
</template>
